@if (videoUrl?.length) {
  <span class="video-wrapper">
    <video
      controls
      [muted]="false"
      [autoplay]="false"
      [poster]="thumbnailUrl"
      [style.background-color]="'#a28f6e'"
      >
      <source [src]="videoUrl" type="video/mp4"/>
    </video>
  </span>
} @else {
  <span class="video-wrapper" [style.background-image]="'url(' + thumbnailUrl + ')'"
    [style.background-color]="'#a28f6e'">
  </span>
}
